import { Helmet } from 'react-helmet-async';
// sections
import { RegisterView } from '../../sections/auth';

// ----------------------------------------------------------------------

export default function RegisterPage() {
  return (
    <>
      <Helmet>
        <title> CategorizIA</title>
      </Helmet>

      {/* <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <RegisterView />
      </GoogleOAuthProvider> */}
      <RegisterView/>
    </>
  );
}
